var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Converts a Shopify ProductVariant ID to a namespaced global ID.
 * @param {Number|String} variantId ProductVariant ID
 * @returns {String} Namespaced Global ID
 */
export var convertVariantIdToGlobalId = function (variantId) { return "gid://shopify/ProductVariant/".concat(variantId); };
/**
 * Converts a Shopify namespaced Global ID to a raw ID.
 * @param {String} globalId Namespaced Global ID
 * @returns {String} ID
 */
export var convertGlobalIdToRawId = function (globalId) {
    return globalId.substr(globalId.lastIndexOf('/') + 1);
};
/**
 * Transform forms an array of shopify product tags to an object for easy lookup
 * @param {Array} tags array of colon delimited shopify product tags
 */
export var transformTagsIntoProperties = function (tags) {
    if (tags === void 0) { tags = []; }
    return tags.reduce(function (prev, curr) {
        var _a;
        var separated = curr.split(':');
        var key = separated[0];
        var value = separated.slice(1, separated.length).join(':');
        return __assign(__assign({}, prev), (_a = {}, _a[key] = __spreadArray(__spreadArray([], (prev[key] || []), true), [value.length > 0 ? value : key], false), _a));
    }, {});
};
